export enum DigitalStoreTermsEnum {
  DEFAULT = 'check-box',
  EMPTY = 'empty',
}

export type DigitalStoreAcceptTermsStrategy = DigitalStoreTermsEnum
